(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteGlobalController', ReporteGlobalController);

    ReporteGlobalController.$inject = ['$scope', '$state', '$window','ReporteGlobal', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','LoginService',
    	'AniosEscolares','Instituciones','NivelesEducativosService','ModelosEducativosService','Periodos'];

    function ReporteGlobalController ($scope, $state,$window, ReporteGlobal, ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,
    		AniosEscolares,Instituciones,NivelesEducativosService,ModelosEducativosService,Periodos) {
        var vm = this;
        
       
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        
        vm.download=download;
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.periodos;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
        cargarDropdrown();
//        loadAll();
        vm.isNew = isNew;
        vm.limpiar = limpiar;
        vm.esLicMEFI = esLicMEFI;
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){
        	
        	if (newValue === oldValue) {
      	      return;
      	    }
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	if(vm.intercurso){
        		vm.indicePeriodo = 0;
        	}else{
        		vm.indiceIntercurso = 0;
        	}
	      	
        });
        
        function loadAll () {
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	ReporteGlobal.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function download(indicePeriodo,intercurso,indiceIntercurso,anioSeleccionado,modeloSeleccionado,nivelSeleccionado,institucionSelected){
        	
        	if(anioSeleccionado == 0 || modeloSeleccionado == 0 || nivelSeleccionado == 0 || institucionSelected == 0 || 
        		indicePeriodo == null || intercurso == null || indiceIntercurso == null || anioSeleccionado == null || modeloSeleccionado == null || nivelSeleccionado == null || modeloSeleccionado == '' || nivelSeleccionado == '' || institucionSelected == null   )
        		return ;
        	let parametros = [indicePeriodo,intercurso,indiceIntercurso,anioSeleccionado,modeloSeleccionado,nivelSeleccionado,institucionSelected];
        	ReporteGlobal.downl(parametros,ondownloadSuccess, ondownloadError);
        }
        
        function ondownloadSuccess (result) {
        	//console.log(result);
        }

        function ondownloadError (error) {
        	console.log(error);
        }
        function esLicMEFI(tipo,mefi){
        	if(mefi==="MEFI" || mefi==="MEFI_2"){
        		if(tipo=='Licenciatura'){
        			return true;
        		}
        	}
        	
        	return false;
        }


        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onSuccess,{reload:false});
       	 function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.usuarios = data;
             vm.page = pagingParams.page;
         }
        }
        
        function isNew(){
        	if( vm.usuarios.evaluacion.id ==null )
        		return true;
        	else
        		return false;
        }
        
        function cargarDropdrown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=Instituciones.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }
        
        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;
        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                aniostr: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes
            },onSuccess);
        	 function onSuccess(data, headers) {
                 vm.links = ParseLinks.parse(headers('link'));
                 vm.totalItems = headers('X-Total-Count');
                 vm.queryCount = vm.totalItems;
                 vm.usuarios = data;
                 vm.page = pagingParams.page;
             }
        	
        }

    }
})();
